<script>
import gql from "graphql-tag";
import { locationVenueFragment } from "@/graphql/location";
import { DialogInputTypes } from "@/js/helper";
import BaseDialog from "./baseDialog.vue";

export default {
  name: "AddVenueDialog",
  extends: BaseDialog,
  props: { location: Object },
  data: function() {
    return {
      names: {
        label: "Name of venue(s)"
        //hint: "Separate names with semi-colons"
      }
    };
  },
  computed: {
    dialogInputs: {
      get() {
        return [this.names];
      }
    },
    title: {
      get() {
        return "Add venue";
      }
    },
    instructions: {
      get() {
        return "Add one or more venue by name.";
      }
    }
  },
  methods: {
    submit() {
      const venues = this.names.value
        .split(";")
        .filter(x => x)
        .forEach(async name => {
          await this.$apollo
            .mutate({
              mutation: gql`
                mutation($locationId: ID!, $venue: VenueInput!) {
                  upsertVenue(locationId: $locationId, venue: $venue) {
                    ...LocationVenue
                  }
                }
                ${locationVenueFragment}
              `,
              variables: {
                locationId: this.location.id,
                venue: { name: name.trim() }
              }
            })
            .then(result => {
              this.$root.$emit("updateLocation", this.location.id);
              this.$store.commit("setNotification", `Added venues`);
            })
            .catch(err => {
              console.log(err);
              window.alert("Failed to add venues");
            });
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// addVenueDialog.vue?6cd8611c